import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { loanPledge } from '@/config/sensors';
import { saPushEvent } from '@/utils/sensors';
import { replace } from '@/locales/i18n';
import { replaceDomainToLocation, noDmainUrl } from '@/utils/url';
import { QUESTIONS } from '../constant/question';
export default {
  setup() {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const activeName = ref(['1', '2', '3', '4', '5', '6', '7']);
    const handleClick = index => {
      saPushEvent(loanPledge.faq, {
        page_name: loanPledge.home,
        plate_area: 'Bottom',
        button_name: index
      });
    };
    return {
      t,
      activeName,
      QUESTIONS,
      handleClick,
      replace,
      noDmainUrl,
      replaceDomainToLocation
    };
  }
};